import React from 'react';
import type { TripGroupRow } from '../../../types/tripsMonitoredUsage';
import { formatNumber } from '../utils/formatNumber';
import { useTableSort } from '../hooks/useTableSort';
import TableHeader from './TableHeader';
import SortableColumnHeader from './SortableColumnHeader';
import tableStyles from '../../../components/table/styles.module.css';
import styles from './tripGroupsTable.module.css';

interface TripGroupsTableProps {
  data: TripGroupRow[];
  periodColumns: string[];
  onExport: () => void;
}

const TripGroupsTable: React.FC<TripGroupsTableProps> = ({
  data,
  periodColumns,
  onExport,
}) => {
  const { sortedData, sortKey, sortDirection, handleSort } = useTableSort(data);

  return (
    <div className={styles.wrapper}>
      <TableHeader title="Trips by trip group" onExport={onExport} />
      <div className={styles.scrollArea}>
        <table className={`${tableStyles.table} ${tableStyles.tableStriped}`}>
          <thead className={tableStyles.tableHead}>
            <tr>
              <SortableColumnHeader
                label="Trip Group"
                columnKey="tripGroup"
                sortKey={sortKey}
                sortDirection={sortDirection}
                onSort={handleSort}
                className={styles.firstCol}
                iconPosition="right"
              />
              {periodColumns.map(col => (
                <SortableColumnHeader
                  key={col}
                  label={col}
                  columnKey={col}
                  sortKey={sortKey}
                  sortDirection={sortDirection}
                  onSort={handleSort}
                  className={styles.periodHeader}
                />
              ))}
            </tr>
          </thead>
          <tbody className={tableStyles.tbody}>
            {sortedData.length === 0 ? (
              <tr>
                <td colSpan={periodColumns.length + 1} className={tableStyles.noRowsValue}>
                  No data available
                </td>
              </tr>
            ) : (
              sortedData.map(row => (
                <tr key={row.tripGroup}>
                  <td className={styles.firstCol}>{row.tripGroup}</td>
                  {periodColumns.map(col => (
                    <td key={col}>
                      {typeof row[col] === 'number'
                        ? formatNumber(row[col] as number)
                        : (row[col] ?? '—')}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TripGroupsTable;
